import QrModal from '@components/common/qr-modal/qr-modal.tsx';
import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Route } from '@helpers/types';
import {
  IStationSwitcherContext,
  StationSwitcherContext,
} from '@components/providers/station/context.tsx';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { QrCode2 } from '@mui/icons-material';
import { useHttp } from '@hooks/use-http';

interface ITableInduction {
  routes: Array<Route>;
  progress: any;
  onPrintContainer: (
    container_id: string,
    container_name: string,
    route: string,
  ) => Promise<void>;
}

export const TableInduction = (props: ITableInduction) => {
  const http = useHttp();
  const { destStation, station: currStation } =
    useContext<IStationSwitcherContext>(StationSwitcherContext);
  return (
    <TableContainer
      sx={{
        borderRadius: 2,
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'action.hover' }}>
            <TableCell sx={{ fontWeight: 'bold' }}>Ruta</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Contenedor</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }} align="center">Progreso</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }} align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.routes.map((route) => {
            const progress = props.progress[route.name] || 0;
            const total = route?.orders?.length || 0;
            const isComplete = progress === total && total > 0;

            return (
              <TableRow
                key={route.id}
                sx={{
                  '&:hover': { backgroundColor: 'action.hover' },
                  backgroundColor: isComplete ? 'success.lighter' : 'inherit',
                }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    {route.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {route.container_name}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    color={isComplete ? 'success.main' : 'primary'}
                  >
                    {progress}/{total}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Stack direction="row" spacing={1} justifyContent="center">
                    {destStation && (
                      <QrModal
                        station={destStation}
                        qr={route.container}
                      />
                    )}
                    {currStation && destStation && currStation.station != destStation.station && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          http.induction.lmToMMContainer(
                            destStation.station,
                            route.container,
                          ).then(() => {
                            toast.success(
                              'El contenedor ahora puede ser inducido en lineaul',
                            );
                          });
                        }}
                      >
                        <LocalShippingIcon fontSize="small" />
                      </Button>
                    )}
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<QrCode2 />}
                      onClick={() =>
                        props.onPrintContainer(
                          route.container,
                          route.container_name,
                          route.name,
                        )
                      }
                    >
                      Imprimir
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
